export const SAVE_ALL_RECIPES = 'SAVE_ALL_RECIPES'